import React, { FunctionComponent } from "react";

type ErrorProps = {
  description: string;
};

const Error: FunctionComponent<ErrorProps> = ({ description }) => <p>{description}</p>;

export default Error;
